/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';

import { ApiStatus } from '../../../../../ts';
import { CreateAsyncThunk, SkillsSlice } from '../../../../../ts/state';
import * as API from '../../../api/skills';
import { addErrorMessage } from '../../messages/actions';

export const listUserLabels = createAsyncThunk<
  string[],
  string,
  CreateAsyncThunk
>('skills/listUserLabels', async (skillId, { dispatch }) => {
  try {
    if (!skillId) {
      return;
    }

    const response = await API.listUserLabels(skillId);
    return response;
  } catch (error) {
    dispatch(addErrorMessage(error));
    throw error;
  }
});

const reducer = (builder: ActionReducerMapBuilder<SkillsSlice>) => {
  builder
    .addCase(listUserLabels.pending, (state, action) => {
      const { arg: id } = action.meta;
      state.userLabelsStatus = ApiStatus.LOADING;
      state.userLabels[id] = {
        status: ApiStatus.LOADING,
        nodes: state.userLabels[id]?.nodes ?? []
      };
      state.userLabelsError = null;
    })
    .addCase(listUserLabels.fulfilled, (state, action) => {
      const { arg: id } = action.meta;
      state.userLabelsStatus = ApiStatus.SUCCEEDED;
      state.userLabelsError = null;
      state.userLabels[id] = {
        status: ApiStatus.SUCCEEDED,
        nodes: action.payload
      };
    })
    .addCase(listUserLabels.rejected, (state, action) => {
      const { arg: id } = action.meta;
      state.userLabelsStatus = ApiStatus.ERROR;
      state.userLabels[id] = {
        status: ApiStatus.ERROR,
        nodes: state.userLabels[id]?.nodes ?? []
      };
      state.userLabelsError = action.error;
    });
};

export default reducer;
